import type { DisplayCue, PersonalizeCoverageResponse } from "@expert/contentful";

export function getDetectedDeviceExamples(
    devices: DisplayCue[],
    personalizedExamples: PersonalizeCoverageResponse[],
): { text: string; highlights: string[] }[] {
    const examples: { text: string; highlights: string[] }[] = [];
    const detectedDevices = devices.filter((device) => device.detected || device.isDetectedOnPreviousCall);
    if (!detectedDevices.length) {
        return [];
    }

    // detectedDevices have higher priority than previous detected devices
    const sortedDevices = detectedDevices.toSorted((a, b) => {
        if (a.detected !== b.detected) {
            return a.detected ? -1 : 1;
        }
        if (a.isDetectedOnPreviousCall !== b.isDetectedOnPreviousCall) {
            return a.isDetectedOnPreviousCall ? 1 : -1;
        }
        return (a.rank ?? Number.MAX_VALUE) - (b.rank ?? Number.MAX_VALUE);
    });

    sortedDevices.forEach((device) => {
        const matchingExample = personalizedExamples.find(
            (example) => example.deviceName.toLowerCase() === device.name.toLowerCase(),
        );

        if (matchingExample)
            examples.push(
                ...matchingExample.examples.map((example) => {
                    return {
                        text: example,
                        highlights: [
                            matchingExample.deviceName,
                            matchingExample.deviceName + "s",
                            matchingExample.deviceName + "es",
                        ],
                    };
                }),
            );
    });

    return examples.slice(0, 4); // we should only display 4 examples
}
